module.exports = __webpack_public_path__ + "static/media/MEA_new-1colorcenter.46df14d6.png";